import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import EditPaymentProviderModal
  from 'components/dashboard/settings-content/commerce/modals/EditPaymentProviderModal';

import './MyPaymentProviderItem.css';

function MyPaymentProviderItem(props) {
  const { item } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="my-payment-provider-item__component">
      <div
        className="item-wrapper"
        onClick={() => setModalOpen(true)}
        role="button"
        tabIndex={-1}
      >
        <div className={`icon ${item.provider_name.toLowerCase()}`} />
        <div className="provider-title">{item.provider_title}</div>
        {!item.charges_enabled &&
          <div className="provider-disabled">{t("(Payments Disabled)")}</div>
        }
        <div className="icon arrow" />
      </div>

      {/* Edit Payment Provider Modal */}
      <EditPaymentProviderModal
        item={item}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
}

MyPaymentProviderItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default MyPaymentProviderItem;
